import { useState, useEffect } from "react";

const useDeviceDetection = () => {
  const [device, setDevice] = useState("");
  const [orientation, setOrientation] = useState("");

  const detectOrientation = () => {
    return window.matchMedia("(orientation: portrait)").matches ? "Portrait" : "Landscape";
  };

  useEffect(() => {
    const handleDeviceDetection = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobile =
        /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent);
      const isTablet =
        /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent);
      const screenWidth = window.innerWidth;

      if (isMobile || screenWidth < 680) {
        setDevice(DEVICE_TYPE.MOBILE);
      } else if (isTablet || (screenWidth >= 680 && screenWidth <= 1024)) {
        setDevice(DEVICE_TYPE.TABLET);
      } else {
        setDevice(DEVICE_TYPE.DESKTOP);
      }

      setOrientation(detectOrientation());
    };

    handleDeviceDetection();
    window.addEventListener("resize", handleDeviceDetection);
    window.addEventListener("orientationchange", handleDeviceDetection);

    return () => {
      window.removeEventListener("resize", handleDeviceDetection);
      window.removeEventListener("orientationchange", handleDeviceDetection);
    };
  }, []);

  return { device, orientation };
};

export const DEVICE_TYPE = {
  MOBILE: "Mobile",
  TABLET: "Tablet",
  DESKTOP: "Desktop",
};

export const DEVICE_ORIENTATION = {
  PORTRAIT: "Portrait",
  LANDSCAPE: "Landscape",
};

export default useDeviceDetection;
